export const FADE_DURATION = 300;
export const WIDTH = 500;
export const HEIGHT = 281;
